// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../apps/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../apps/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qEqeurg9u54mFfGnFpEB{border-inline-start:4px solid currentcolor;border-radius:4px;padding:.5rem .75rem}\n", "",{"version":3,"sources":["webpack://./../frontend/packages/markdown/dist/extensions/callout/callout.module.css"],"names":[],"mappings":"AAAA,sBAAkB,0CAA0C,CAAC,iBAAiB,CAAC,oBAAoB","sourcesContent":["._callout_1i6z6_1{border-inline-start:4px solid currentcolor;border-radius:4px;padding:.5rem .75rem}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"_callout_1i6z6_1": "qEqeurg9u54mFfGnFpEB"
};
export default ___CSS_LOADER_EXPORT___;
